import CreateReleaseContainer from "../containers/CreateReleaseContainer";

const CreateReleasePage = () => {
  return (
    <CreateReleaseContainer />
  );
};

export default CreateReleasePage;
